<nav class="navbar navbar-expand-lg">
  <div class="nav-inner site-content w-full flex flex-wrap items-center justify-between">
    <a class="navbar-brand heading-black" [routerLink]="['/']">
      <img width="200" src="./assets/img/logo-capital-divisas.svg" alt="" />
    </a>
    <div class="nav-mobile-tools d-lg-none" *ngIf="this.notInAuthModule">
      <button class="btn-lang" [matMenuTriggerFor]="langMenuMobile">
        <span>{{ currentLang | uppercase }}</span>
        <mat-icon svgIcon="arrow_drop_down"></mat-icon>
      </button>
      <mat-menu #langMenuMobile="matMenu" xPosition="before">
        <button
          mat-menu-item
          (click)="setLanguage('es')"
          [class.lang-active]="currentLang === 'es'"
        >
          {{ "SHARED.LANG_SPANISH" | translate }}
        </button>
        <button
          mat-menu-item
          (click)="setLanguage('en')"
          [class.lang-active]="currentLang === 'en'"
        >
          {{ "SHARED.LANG_ENGLISH" | translate }}
        </button>
      </mat-menu>

      <div
        class="nav-mobile-tools__actions"
        *ngIf="(this.isAuth.userIsAuthenticated$ | async)?.token == null"
      >
        <a
          class="btn-register d-inline-flex flex-row align-items-center text-capitalize"
          [routerLink]="['auth', 'sign-up']"
        >
          <mat-icon svgIcon="person"></mat-icon>
        </a>
        <button
          class="navbar-toggler navbar-toggler-right"
          [routerLink]="['auth', 'login']"
          type="button"
        >
          <mat-icon svgIcon="login" aria-hidden="true"></mat-icon>
        </button>
      </div>

      <div
        class="navbar-toggler navbar-toggler-profile navbar-toggler-right"
        *ngIf="(this.isAuth.userIsAuthenticated$ | async)?.token !== null"
        style="border: 0px !important"
      >
        <button
          mat-mini-fab
          color="accent"
          [attr.aria-label]="'NAV.MY_RESERVATIONS' | translate"
          class="d-block icon-sm-button my-auto nav-reservations-btn"
          [class.nav-reservations-btn--has-notice]="
            reservationsService.activeNoticeCollapsed$ | async
          "
          [routerLink]="['reservations']"
        >
          <mat-icon svgIcon="payments"></mat-icon>
        </button>
        <button
          mat-mini-fab
          color="accent"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNavAuthCollapse"
          aria-controls="navbarNavAuthCollapse"
          aria-expanded="false"
          [attr.aria-label]="'SHARED.ARIA_TOGGLE_NAV' | translate"
          class="btn-circle d-block icon-sm-button my-auto nav-user-btn"
        >
          <img
            *ngIf="avatarUrl"
            class="nav-user-avatar"
            [src]="avatarUrl"
            alt=""
          />
          <mat-icon *ngIf="!avatarUrl" svgIcon="account_circle"></mat-icon>
        </button>
      </div>
    </div>

    <div class="collapse navbar-collapse" id="navbarNavAuthCollapse">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0 d-md-block d-lg-none">
        <li class="nav-item menu-dropdown">
          <a
            class="nav-link-divisa"
            aria-current="page"
            [routerLink]="['/profile-new']"
          >
            <mat-icon svgIcon="person"></mat-icon>
            {{ "NAV.MY_PROFILE" | translate }}</a
          >
        </li>
        <li class="nav-item menu-dropdown">
          <a
            class="nav-link-divisa"
            aria-current="page"
            [routerLink]="['reservations']"
          >
            <mat-icon svgIcon="payment"></mat-icon>
            {{ "NAV.MY_RESERVATIONS" | translate }}</a
          >
        </li>
        <li class="nav-item menu-dropdown">
          <a
            class="nav-link-divisa"
            aria-current="page"
            [routerLink]="['wallet']"
          >
            <mat-icon svgIcon="local_offer"></mat-icon>
            {{ "NAV.WALLET" | translate }}</a
          >
        </li>
        <li class="nav-item menu-dropdown">
          <a
            class="nav-link-divisa"
            aria-current="page"
            [routerLink]="['marketplace']"
          >
            <mat-icon svgIcon="shopping_bag"></mat-icon>
            {{ "NAV.MARKETPLACE" | translate }}</a
          >
        </li>
        <li class="nav-item menu-dropdown">
          <a
            class="nav-link-divisa"
            aria-current="page"
            [routerLink]="['/app', 'graficas']"
          >
            <mat-icon svgIcon="currency_exchange"></mat-icon>
            {{ "NAV.CHARTS" | translate }}</a
          >
        </li>
        <li class="nav-item menu-dropdown">
          <a
            type="button"
            class="nav-link-divisa nav-logout-btn"
            (click)="logout()"
          >
            <mat-icon svgIcon="logout"></mat-icon>
            {{ "NAV.LOGOUT" | translate }}
          </a>
        </li>
      </ul>

      <ul
        class="navbar-nav me-auto my-2 my-lg-0 navbar-nav-scroll"
        style="--bs-scroll-height: 100px"
      ></ul>

      <div class="d-none d-lg-inline-flex align-items-center gap-2 me-3">
        <button class="btn-lang" [matMenuTriggerFor]="langMenu">
          <span>{{ currentLang | uppercase }}</span>
          <mat-icon svgIcon="arrow_drop_down"></mat-icon>
        </button>
        <mat-menu #langMenu="matMenu" xPosition="before">
          <button
            mat-menu-item
            (click)="setLanguage('es')"
            [class.lang-active]="currentLang === 'es'"
          >
            {{ "SHARED.LANG_SPANISH" | translate }}
          </button>
          <button
            mat-menu-item
            (click)="setLanguage('en')"
            [class.lang-active]="currentLang === 'en'"
          >
            {{ "SHARED.LANG_ENGLISH" | translate }}
          </button>
        </mat-menu>
      </div>

      <div
        *ngIf="
          (this.isAuth.userIsAuthenticated$ | async)?.token == null &&
          this.notInAuthModule
        "
        class="d-inline-flex align-items-center gap-2"
      >
        <a
          class="btn-register d-inline-flex flex-row align-items-center text-capitalize"
          [routerLink]="['auth', 'sign-up']"
        >
          <mat-icon svgIcon="person"></mat-icon>
          {{ "NAV.REGISTER" | translate }}
        </a>
        <a
          class="btn btn-primary d-inline-flex flex-row align-items-center text-capitalize"
          [routerLink]="['auth', 'login']"
        >
          {{ "NAV.LOGIN" | translate }}
          <mat-icon svgIcon="login"></mat-icon>
        </a>
      </div>

      <div
        class="d-flex"
        *ngIf="
          (this.isAuth.userIsAuthenticated$ | async)?.token != null &&
          this.notInAuthModule
        "
      >
        <div class="divisa-row">
          <p
            class="text-right pr-2 my-auto d-none d-lg-block"
            style="line-height: 20px"
          >
            {{ "NAV.MY_RESERVATIONS_LINE1" | translate }} <br />
            {{ "NAV.MY_RESERVATIONS_LINE2" | translate }}
          </p>
          <button
            mat-mini-fab
            color="accent"
            [attr.aria-label]="'NAV.MY_RESERVATIONS' | translate"
            class="icon-sm-button my-auto d-none d-lg-block nav-reservations-btn"
            [class.nav-reservations-btn--has-notice]="
              reservationsService.activeNoticeCollapsed$ | async
            "
            [routerLink]="['reservations']"
          >
            <mat-icon svgIcon="payments"></mat-icon>
          </button>
          <button
            mat-mini-fab
            color="accent"
            [attr.aria-label]="'NAV.MY_RESERVATIONS' | translate"
            class="btn-circle icon-sm-button my-auto d-none d-lg-block ml-3 nav-user-btn"
            aria-expanded="false"
            data-bs-toggle="dropdown"
          >
            <img
              *ngIf="avatarUrl"
              class="nav-user-avatar"
              [src]="avatarUrl"
              alt=""
            />
            <mat-icon *ngIf="!avatarUrl" svgIcon="account_circle"></mat-icon>
          </button>
          <div class="my-auto dropdown">
            <ul class="nav-user-auth dropdown-menu dropdown-menu-end">
              <li>
                <a class="dropdown-item" [routerLink]="['/profile-new']">
                  <mat-icon svgIcon="person"></mat-icon>
                  {{ "NAV.MY_PROFILE" | translate }}</a
                >
              </li>
              <li>
                <a class="dropdown-item" [routerLink]="['reservations']">
                  <mat-icon svgIcon="payment"></mat-icon>
                  {{ "NAV.MY_RESERVATIONS" | translate }}</a
                >
              </li>
              <li>
                <a class="dropdown-item" [routerLink]="['wallet']">
                  <mat-icon svgIcon="local_offer"></mat-icon>
                  {{ "NAV.WALLET" | translate }}</a
                >
              </li>
              <li>
                <a class="dropdown-item" [routerLink]="['marketplace']">
                  <mat-icon svgIcon="shopping_bag"></mat-icon>
                  {{ "NAV.MARKETPLACE" | translate }}</a
                >
              </li>
              <li>
                <a class="dropdown-item" [routerLink]="['/app', 'graficas']">
                  <mat-icon svgIcon="currency_exchange"></mat-icon>
                  {{ "NAV.CHARTS" | translate }}</a
                >
              </li>
              <li>
                <a
                  type="button"
                  class="dropdown-item nav-logout-btn"
                  (click)="logout()"
                >
                  <mat-icon svgIcon="logout"></mat-icon>
                  {{ "NAV.LOGOUT" | translate }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</nav>
